import { useEffect } from 'react';
import { wiwAtom } from 'r/atoms';
import { useSetAtom } from 'jotai';
import { debounce } from 'lodash';

export default function useWindowWidth() {
  const setWiw = useSetAtom(wiwAtom);
  useEffect(() => {
    window.addEventListener(
      'resize',
      debounce(() => {
        setWiw(window.innerWidth);
      }, 300),
    );
  }, []);
}
